import React from 'react';
import { Button, Modal } from '@economic/gaudi';
import { ProgressDots } from '../../ui/progressDots/ProgressDots';
import { t } from '../../l10n/l10n';
import Field from '../../Form/Field';
import { Form } from '../../Form';
import { CompanyDeregisterData } from './types';
import ExternalLink from '../../ExternalLink';

interface Props {
    deregisterData: CompanyDeregisterData;
    onError: (error: string) => void;
    onDone: (archiveSubscriptionChosen: boolean) => void;
}

export default function StepChooseSubscription({ deregisterData, onDone, onError }: Props) {
    function handleSubmit(values: { subscription: number }) {
        if (validate(values)) {
            onDone(values.subscription === 1);
        }
    }

    function validate(values: { subscription: number }) {
        if (values.subscription === undefined) {
            onError(t('FORM_COMPANY_DEREGISTER_CHOOSESUBSCRIPTION_ERROR_CHOOSE_OPTION'));
            return false;
        }

        return true;
    }

    return (
        <div>
            <div style={{ marginBottom: 15 }}>
                <ProgressDots stepsCount={2} currentStep={1} />
            </div>
            <Form onSubmit={handleSubmit} initialData={deregisterData} skipNotifications>
                <Modal.Header>{t`FORM_COMPANY_DEREGISTER_CHOOSESUBSCRIPTION_TITLE`}</Modal.Header>

                <Modal.Content>
                    <div style={{ marginBottom: 15 }}>{t`FORM_COMPANY_DEREGISTER_CHOOSESUBSCRIPTION_CONTENT_1`}</div>
                    <div style={{ marginBottom: 15 }}>{t`FORM_COMPANY_DEREGISTER_CHOOSESUBSCRIPTION_CONTENT_2`}</div>
                    <div className="company-deregister-dialog archive_option">
                        <Field.NumberRadioGroup
                            name="subscription"
                            options={[
                                {
                                    text: t('FORM_COMPANY_DEREGISTER_CHOOSESUBSCRIPTION_ARCHIVE', {
                                        ARCHIVE_SUBSCRIPTION_FEE: deregisterData.archiveSubscriptionPrice,
                                    }),
                                    value: 1,
                                },
                                {
                                    text: t('FORM_COMPANY_DEREGISTER_CHOOSESUBSCRIPTION_DEREGISTER'),
                                    value: 0,
                                },
                            ]}
                        />
                    </div>
                    <div>{t`FORM_COMPANY_DEREGISTER_CHOOSESUBSCRIPTION_CONTENT_3`}</div>
                </Modal.Content>

                <Modal.Footer>
                    {deregisterData.learnMoreLink && (
                        <div className="company-deregister-dialog learn_more">
                            <ExternalLink href={deregisterData.learnMoreLink}>
                                {t`FORM_COMPANY_DEREGISTER_CHOOSESUBSCRIPTION_LEARNMORE`}
                            </ExternalLink>
                        </div>
                    )}
                    <Button appearance="primary" type="submit">
                        {t('FORM_COMPANY_DEREGISTER_CHOOSESUBSCRIPTION_NEXT')}
                    </Button>
                </Modal.Footer>
            </Form>
        </div>
    );
}
